<main style="text-align: center; background-color: white; height: 100%; position: relative;">
    <div style="height: 40px;"></div>
    <img src="assets/stats-ss.png" style="height: 700px;">
</main>
